export const instructions = [{
  title:(<>
    All fields marked &quot;<span className="mandatory">*</span>&quot; must be completed.
    </>
    ),
  link: '/'
}, {
  title: (<>{'Use the '}<span>&quot;Save as Draft&quot;</span>{' button to save your changes.'}</>),
  link: '/'
}, {
  title:(<>Use <span>&quot;Submit/Update&quot;</span> button to submit/Update your request.</>),
  link: '/'
}, {
  title: (<>Use <span>&quot;Cancel&quot;</span> button to close the request.</>),
  link: '/'
}]
